import { CrossBrowserContext } from 'contexts/crossBrowserContext/CrossBrowserContext';
import { useContext } from 'react';

export const useCrossBrowserContext = () => useContext(CrossBrowserContext);
